export default "__VITE_ASSET__CLu_IZhz__"